/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import Card from '../../card'
import { ImageInline } from '../../image'
import Paragraph from '../../paragraph'
import VideoWrapper from '../../video-wrapper'

import { FlexCols, FlexCol, VStack } from '../../../styles/els'
import { formatImage, resolveButtons } from '../../../lib/helpers'

import Img from './about_diagram.png'

const AboutDiagram = (props) => {
  const { ...otherProps } = props

  return (
    <ImageInline
      image={{
        src: Img,
        width: 2720,
        height: 1088,
      }}
      sx={{
        pointerEvents: 'none',
      }}
    />
  )
}

export default AboutDiagram
